import { getModuleName } from './token'

export function toSnakeCase(camelCase) {
  return camelCase.split(/(?=[A-Z])/).join('_').toLowerCase()
}

function formatQueryString(queryName, queryString) {
  return `${toSnakeCase(queryName)}=${queryString}`
}

function formatQueryArray(queryName, queryArray) {
  return queryArray
    .map(arrayEl => formatQueryString(`${queryName}[]`, arrayEl))
    .join('&')
}

export function composeQuery(queryObject) {
  return Object.keys(queryObject)
    .map((name) => {
      const value = queryObject[name]

      return Array.isArray(value)
        ? formatQueryArray(name, value)
        : formatQueryString(name, value)
    })
    .join('&')
}

export function getQuery() {
  return window.location.search
    .substr(1)
    .split('&')
    .reduce((params, param) => {
      const [key, val] = param.split('=')

      return key && val ? { ...params, [key]: val } : params
    }, {})
}

export async function getPreSignedUrl(url) {
  const moduleName = getModuleName()
  const response = await window.axios.get(`/api/${moduleName}/get-pre-signed-url`, {
    params: {
      key: url,
    },
  })
  const { url: preSignedUrl } = response.data
  return preSignedUrl
}

export default null
